import React, { useEffect, useState } from 'react';
import './AnnouncementModal.scss';

function AnnouncementModal({
  isOpen,
  onRequestClose,
  title = "공지사항",
  content = "",
  showDontShowAgain = true
}) {
  const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setDontShowAgain(false);
    }
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  const handleClose = (forceDontShowAgain) => {
    if (typeof onRequestClose === 'function') {
      const shouldHide = typeof forceDontShowAgain === 'boolean' ? forceDontShowAgain : dontShowAgain;
      onRequestClose(shouldHide);
    }
  };

  // ul/li에 클래스 추가하는 함수
  const addListClasses = (htmlContent) => {
    if (!htmlContent) return '';
    
    let processed = htmlContent
      .replace(/<ul[^>]*>/gi, '<ul class="announcement-list">')
      .replace(/<ol[^>]*>/gi, '<ol class="announcement-list">')
      .replace(/<li[^>]*>/gi, '<li class="announcement-list-item">');
    
    return processed;
  };

  const processedContent = addListClasses(content);

  return (
    <div className="announcement-overlay">
      <div
        className="announcement-modal-container"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="announcement-close-button"
          onClick={() => handleClose()}
          aria-label="닫기"
        >
          ✕
        </button>

        <div className="announcement-hero">
          <h2 dangerouslySetInnerHTML={{ __html: title }}></h2>
          {content && (
            <div 
              className="announcement-content"
              dangerouslySetInnerHTML={{ __html: processedContent }}
            />
          )}
        </div>

        {showDontShowAgain && (
          <label className="announcement-checkbox-footer">
            <input
              type="checkbox"
              checked={dontShowAgain}
              onChange={(event) => {
                const { checked } = event.target;
                setDontShowAgain(checked);
                if (checked) {
                  handleClose(true);
                }
              }}
            />
            다시 보지 않기
          </label>
        )}
      </div>
    </div>
  );
}

export default AnnouncementModal;
